(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["SeriesFilter"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSeriesFilter(container) {
      if (container.dataset.sfInit === '1') return;
      

      container.dataset.sfInit = '1';

      const tabs = container.querySelectorAll('.tab-btn');
      const filter = container.querySelector('.filter');
      const filterGroups = container.querySelectorAll('.filter-group');
      const productGroups = container.querySelectorAll('.Mainproducts_Pro');

      function updateFilterVisibility(group) {
        if (! filter) return;
        const optionCount = group ? group.querySelectorAll('.custom-select-option').length : 0;
        filter.classList.toggle('is-hidden', optionCount <= 1);
      }

// —— 折叠逻辑 ——
      function collapseGroup(group) {
        const items = group.querySelectorAll('.SeriesFilter_itme');
        const btn = group.querySelector('.view-all-btn');
        items.forEach((it, idx) => {
          it.classList.toggle('is-hidden', idx >= 4);
        });
        if (btn) {
          if (items.length > 4) {
            btn.style.display = '';
            btn.textContent = btn.dataset.textMore;
            btn.setAttribute('aria-expanded', 'false');
          } else {
            btn.style.display = 'none';
          }
        }
      }

// —— 激活 lazy group(把 <template> 内容渲染出来)——
      function activateGroup(group) {
        if (group.dataset.activated === '1') return;
        
        const url = group.dataset.url;
        if (! url) {
          group.dataset.activated = '1';
          return;
        }
        group.dataset.activated = '1';
        group.innerHTML = '<div class="sf-loading" style="padding:24px;text-align:center;width:100%;">Loading…</div>';
        fetch(url).then(r => r.text()).then(html => {

// 备用模板只输出网格 HTML，直接放进容器
          group.innerHTML = html.trim();
          collapseGroup(group);
        }).catch(() => {
          group.dataset.activated = '0';
          group.innerHTML = '';
        });
      }

// —— TAB 切换 ——
      tabs.forEach(tab => {
        tab.addEventListener('click', function() {
          const index = this.dataset.index;
          tabs.forEach(t => t.classList.remove('active'));
          this.classList.add('active');

          filterGroups.forEach(g => g.classList.remove('active'));
          const currentGroup = container.querySelector('.filter-group[data-index="' + index + '"]');
          if (! currentGroup) return;
          


          currentGroup.classList.add('active');
          updateFilterVisibility(currentGroup);
          container.querySelectorAll('.custom-select-wrapper.open').forEach(w => w.classList.remove('open'));

          const firstOption = currentGroup.querySelector('.custom-select-option');
          if (firstOption) 
            firstOption.click();
          

        });
      });

// —— 下拉 / 选项 ——
      container.addEventListener('click', function(e) {

// 打开/关闭 dropdown
        const trigger = e.target.closest('.custom-select-trigger');
        if (trigger && container.contains(trigger)) {
          e.stopPropagation();
          const wrapper = trigger.closest('.custom-select-wrapper');
          container.querySelectorAll('.custom-select-wrapper').forEach(w => {
            if (w !== wrapper) 
              w.classList.remove('open');
            

          });
          wrapper.classList.toggle('open');
          return;
        }

// 选择某个 collection
        const option = e.target.closest('.custom-select-option');
        if (option && container.contains(option)) {
          e.stopPropagation();
          const wrapper = option.closest('.custom-select-wrapper');
          const handle = option.dataset.collection;

          wrapper.querySelectorAll('.custom-select-option').forEach(o => o.classList.remove('selected'));
          option.classList.add('selected');
          const selectedTextEl = wrapper.querySelector('.selected-text');
          if (selectedTextEl) 
            selectedTextEl.textContent = option.textContent.trim();
          

          wrapper.classList.remove('open');

          productGroups.forEach(group => {
            const match = group.dataset.collection === handle;
            group.classList.toggle('active', match);
            if (match) {
              activateGroup(group); // ← 关键:激活时才渲染图片/脚本
              collapseGroup(group);
            }
          });
          return;
        }

// 查看全部 / 收起
        const viewBtn = e.target.closest('.view-all-btn');
        if (viewBtn && container.contains(viewBtn)) {
          const group = viewBtn.closest('.Mainproducts_Pro');
          const items = group.querySelectorAll('.SeriesFilter_itme');
          const expanded = viewBtn.getAttribute('aria-expanded') === 'true';

          if (! expanded) {
            items.forEach(it => it.classList.remove('is-hidden'));
            viewBtn.textContent = viewBtn.dataset.textLess;
            viewBtn.setAttribute('aria-expanded', 'true');
          } else {
            items.forEach((it, idx) => {
              if (idx >= 4) 
                it.classList.add('is-hidden');
              

            });
            viewBtn.textContent = viewBtn.dataset.textMore;
            viewBtn.setAttribute('aria-expanded', 'false');
          }
        }
      });

// 初始化已渲染 group 的按钮状态(只处理 activated=1 的)
      productGroups.forEach(group => {
        if (group.dataset.activated === '1') 
          collapseGroup(group);
        

      });

// 触发初始 tab(默认 group 已渲染,不会触发模板激活)
      const initialTab = container.querySelector('.tab-btn.active') || container.querySelector('.tab-btn');
      if (initialTab) 
        initialTab.click();
      

    }

    function bootAll() {
      document.querySelectorAll('.SeriesFilter_B').forEach(initSeriesFilter);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }

// 点击外部关闭所有 dropdown
    document.addEventListener('click', function() {
      document.querySelectorAll('.custom-select-wrapper.open').forEach(w => w.classList.remove('open'));
    });

// 主题编辑器
    document.addEventListener('shopify:section:load', function(e) {
      e.target.querySelectorAll('.SeriesFilter_B').forEach(initSeriesFilter);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
